import {
  isPlaceholderPersonDisplayName,
  personDisplayName,
} from "./workspace-chrome";

export type ClerkProfileFields = {
  readonly firstName?: string | null;
  readonly lastName?: string | null;
  readonly fullName?: string | null;
  readonly username?: string | null;
  readonly email?: string | null;
};

export function clerkProfileSyncPayload(input: {
  readonly storedDisplayName: string | null | undefined;
  readonly storedEmail: string | null | undefined;
  readonly clerk: ClerkProfileFields;
}): { display_name?: string; primary_email?: string } | null {
  const next: { display_name?: string; primary_email?: string } = {};
  if (isPlaceholderPersonDisplayName(input.storedDisplayName)) {
    const resolved = personDisplayName({
      firstName: input.clerk.firstName ?? null,
      lastName: input.clerk.lastName ?? null,
      fullName: input.clerk.fullName ?? null,
      username: input.clerk.username ?? null,
      email: input.clerk.email ?? null,
    });
    if (!isPlaceholderPersonDisplayName(resolved) && resolved !== "Account") {
      next.display_name = resolved.slice(0, 100);
    }
  }
  const email = input.clerk.email?.trim() ?? "";
  if (
    (input.storedEmail === null ||
      input.storedEmail === undefined ||
      input.storedEmail.trim().length === 0) &&
    email.includes("@")
  ) {
    next.primary_email = email;
  }
  if (next.display_name === undefined && next.primary_email === undefined) {
    return null;
  }
  return next;
}
